import React, { useCallback } from "react";

import { Snapshot } from "./Snapshot";
import { EventSnapshot } from "../../../types/global";

export type SnapshotListProps = {
  eventType: string;
  snapshots?: EventSnapshot[];
  setState: React.Dispatch<React.SetStateAction<EventSnapshot[]>>;
  isNetworkDynProp: (snapshot: EventSnapshot) => boolean;
  hasNetworkEventEditPerms: () => boolean;
  hasJsDynPropEditPerms: () => boolean;
};

export function SnapshotList({
  eventType,
  setState,
  isNetworkDynProp,
  hasNetworkEventEditPerms,
  hasJsDynPropEditPerms,
  snapshots = [],
}: SnapshotListProps) {
  const handleSnapshotChange = useCallback(
    function handleSnapshotChange(index: number, snapshot: EventSnapshot) {
      setState((snapshots: EventSnapshot[]) => {
        const newList = snapshots.slice();
        newList[index] = snapshot;
        return newList;
      });
    },
    [setState]
  );

  const handleSnapshotDeletion = useCallback(
    function handleSnapshotDeletion(index) {
      setState((snapshots: EventSnapshot[]) => {
        const newSnapshots = snapshots.slice();
        newSnapshots.splice(index, 1);
        return newSnapshots;
      });
    },
    [setState]
  );

  const renderedSnapshots = snapshots.map((snapshot, index) => {
    return (
      <Snapshot
        eventType={eventType}
        key={`snapshot-list-item-${index}`}
        index={index}
        snapshot={snapshot}
        onChange={handleSnapshotChange}
        onDelete={handleSnapshotDeletion}
        isNetworkDynProp={isNetworkDynProp}
        hasNetworkEventEditPerms={hasNetworkEventEditPerms}
        hasJsDynPropEditPerms={hasJsDynPropEditPerms}
      />
    );
  });

  return <>{renderedSnapshots}</>;
}
